<template>
  <master-layout>
    <div v-if="!loading" class="mb-6 w-full">
      <BackButton variant="inline" @click="backButton" />
      <div class="px-[24px] md:px-8 lg:px-[56px]">
        <Selector
          :selectorTitle="title"
          :buttons="languageList"
          :selectedValue="selectedLanguage"
          @button-selected="handleButtonSelected"
        />
      </div>
    </div>
  </master-layout>
</template>

<script>
import Selector from '@/components/common/Selector.vue';
import BackButton from '@/components/common/BackButton.vue';
import { getCurrentLocale, setLocale, languageList } from '../../utils/deviceLocale.js';
import platformMixin from '@/mixins/platformMixin';

export default {
  mixins: [platformMixin],
  components: {
    Selector,
    BackButton,
  },
  data() {
    return {
      loading: false,
      selectedLanguage: 'en',
      languageList: languageList,
    };
  },
  async ionViewDidEnter() {
    this.selectedLanguage = await getCurrentLocale('Regional');
    this.loading = false;
  },
  computed: {
    title() {
      return this.$t('copy.languagePage.title');
    },
  },
  methods: {
    backButton() {
      this.$router.push('/gpcr/home');
    },
    handleButtonSelected(selectedLanguage) {
      this.selectedLanguage = selectedLanguage;
      this.loading = true;
      setLocale(this.selectedLanguage, this.$i18n, 'Regional');
      this.$router.push('/gpcr/home');
    },
  },
};
</script>

<style></style>
